"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicCoreBaseModuleFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicBorrowIndex",
                type: "uint256",
            },
        ],
        name: "DistributedBorrowerTonic",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicSupplyIndex",
                type: "uint256",
            },
        ],
        name: "DistributedSupplierTonic",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "error",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "info",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "detail",
                type: "uint256",
            },
        ],
        name: "Failure",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "_borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "_mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accountAssets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "accountLookup",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "adminModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allMarkets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowCapGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowCaps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "claimTokenHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "closeFactorMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getTonicAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastContributorBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationIncentiveMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "liquidityCheckWhiteList",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "markets",
        outputs: [
            {
                internalType: "bool",
                name: "isListed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "collateralFactorMantissa",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isTonicized",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract PriceOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingTectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "seizeGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplyCaps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicVaultContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokenRewarderAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenToPerUserTvlProtectLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowerIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicContributorSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicInitialIndex",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplierIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplyState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmountCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultLastBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultSpeed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "transferGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "utilizedTvlAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "whitelistProtectEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedAddresses",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicCoreBaseModuleFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicCoreBaseModuleFactory = TectonicCoreBaseModuleFactory;
TectonicCoreBaseModuleFactory.bytecode = _bytecode;
TectonicCoreBaseModuleFactory.abi = _abi;
//# sourceMappingURL=TectonicCoreBaseModuleFactory.js.map